import { render, staticRenderFns } from "./AffiliateDetailView.vue?vue&type=template&id=4ccb7e8e&"
import script from "./AffiliateDetailView.vue?vue&type=script&lang=ts&"
export * from "./AffiliateDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports